import { render, staticRenderFns } from "./scarica.vue?vue&type=template&id=94b68cce&scoped=true&"
import script from "./scarica.vue?vue&type=script&lang=js&"
export * from "./scarica.vue?vue&type=script&lang=js&"
import style0 from "./scarica.vue?vue&type=style&index=0&id=94b68cce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b68cce",
  null
  
)

export default component.exports